import Bio from '@commons/profile/bio'
import Availabilities from './availabilities'
import Column from '@components/column'
const Overview = () => {
  return (
    <Column rowGap={20}>
      <Bio title="About Institution" />
      <Availabilities />
    </Column>
  )
}

export default Overview
